export default function Card({ title, value, sub, chip }) {
    return (
        <div className="card">
            <div className="card-header">
                <span className="card-title">{title}</span>
                {chip && <span className="chip">{chip}</span>}
            </div>

            <div className="card-value">{value}</div>
            <div className="card-sub">{sub}</div>
        </div>
    );
}
